import { useEffect, useState } from "react";

const useCameraPermission = () => {
	const [cameraPermission, setCameraPermission] = useState("prompt");

	useEffect(() => {
		let permissionStatus;

		const checkPermission = async () => {
			try {
				permissionStatus = await navigator.permissions.query({ name: "camera" });
				setCameraPermission(permissionStatus.state);

				// Listen for permission changes
				permissionStatus.onchange = () => {
					setCameraPermission(permissionStatus.state);
				};
			} catch (error) {
				console.error("Permission API not supported or failed:", error);
			}
		};

		checkPermission();

		return () => {
			if (permissionStatus) {
				permissionStatus.onchange = null;
			}
		};
	}, []);

	return cameraPermission;
};

export default useCameraPermission;
